import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  STANDBY_GET_ALTERNATIVE_OFFERS_STORE_NAME,
  StandbyGetAlternativeOffersState,
} from './standby-get-alternative-offers.state';

/** Select StandbyGetAlternativeOffers State */
export const selectStandbyGetAlternativeOffersState = createFeatureSelector<StandbyGetAlternativeOffersState>(
  STANDBY_GET_ALTERNATIVE_OFFERS_STORE_NAME
);

/** Select StandbyGetAlternativeOffers isPending status */
export const selectStandbyGetAlternativeOffersIsPendingStatus = createSelector(
  selectStandbyGetAlternativeOffersState,
  (state) => !!state.isPending
);

/** Select StandbyGetAlternativeOffers isFailure status */
export const selectStandbyGetAlternativeOffersIsFailureStatus = createSelector(
  selectStandbyGetAlternativeOffersState,
  (state) => !!state.isFailure
);

/** Select StandbyGetAlternativeOffersResult state.model */
export const selectStandbyGetAlternativeOffersResponse = createSelector(
  selectStandbyGetAlternativeOffersState,
  (state) => state.model
);
